import { createSvgIcon } from '@automata/mui-theme';
export const CytivaViaFreezeQuadIcon = createSvgIcon(
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39.9948 7.76636L78 29.6324V76.8733L58.3255 88.0399L42.5286 86.4602L22.6882 74.9736L20.5 65.674V37.4999C20.5005 33.6111 20.5003 29.7222 20.5002 25.8334C20.5001 23.889 20.5 21.9445 20.5 19.9999V19.1383L39.9948 7.76636ZM40.0052 11.2334L23.5 20.8614C23.5 22.5186 23.5001 24.1758 23.5002 25.833C23.5003 29.7219 23.5005 33.611 23.5 37.4999C23.5 37.4998 23.5 37.5 23.5 37.4999V65.3258L25.3118 73.0261L43.4714 83.5395L57.6745 84.9599L75 75.1265V31.3674L40.0052 11.2334Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.3367 28.3255L22.9544 20.7021L21.0454 21.2987L23.6631 29.6753L42.6901 40.4744L58.2254 42.028L75.5069 31.8624L74.4929 30.1385L57.7744 39.9729L43.3097 38.5264L25.3367 28.3255Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.6426 39.5146L23.3576 38.4856L24.7247 40.7641L43.4386 51.5985L58.3715 57.5716L57.6287 59.4286L42.5616 53.4017L23.2755 42.2361L21.6426 39.5146Z"
    />
    <path fillRule="evenodd" clipRule="evenodd" d="M57 85.5V41.5H59V85.5H57Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.003 60.1008L21.5137 45.1647L23.4865 44.8359L25.9971 59.8999L26.4994 73.9646L24.5007 74.036L24.003 60.1008Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M57.9042 58.1973L59.0958 59.8035L44 71.0036V85.0004H42V69.9971L57.9042 58.1973Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M41.9932 71.3616L24.9932 61.3616L26.0072 59.6377L43.0072 69.6377L41.9932 71.3616Z"
    />
    <path fillRule="evenodd" clipRule="evenodd" d="M42 52V39.5H44V52H42Z" />
    <path fillRule="evenodd" clipRule="evenodd" d="M24 41.5V29.5H26V41.5H24Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M79.8946 51.5528C80.1416 52.0467 79.9414 52.6474 79.4474 52.8944C76.8567 54.1898 68.0823 59.3207 65.9238 60.5865C65.3356 60.9314 64.6145 60.9522 64.008 60.6449L60.5483 58.892C60.0556 58.6424 59.8586 58.0407 60.1082 57.548C60.3578 57.0554 60.9595 56.8583 61.4522 57.1079L64.9119 58.8609L64.912 58.8613C67.0305 57.6189 75.8852 52.4394 78.553 51.1055C79.047 50.8586 79.6477 51.0588 79.8946 51.5528Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M74.1058 49.5528C74.3528 49.0588 74.9535 48.8586 75.4474 49.1055L79.4474 51.1055C79.9414 51.3525 80.1416 51.9532 79.8946 52.4472C79.6477 52.9412 79.047 53.1414 78.553 52.8944L74.553 50.8944C74.059 50.6474 73.8588 50.0467 74.1058 49.5528Z"
    />
  </svg>,
  'CytivaViaFreezeQuadIcon'
);
